import { withWidth } from "@material-ui/core";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";
import { WithWidth } from "@material-ui/core/withWidth";
import React, { useMemo } from "react";

const WidthReactContext = React.createContext<Breakpoint>("md");
const IsMobileReactContext = React.createContext<boolean>(false);

export function useWidth() {
	return React.useContext(WidthReactContext);
}

export function useIsMobile() {
    return React.useContext(IsMobileReactContext);
}

interface Mui3WidthProviderProps extends WithWidth {}

function Mui3WidthProvider(props: React.PropsWithChildren<Mui3WidthProviderProps>) {
	const isMobile = useMemo(() => props.width === "xs" || props.width === "sm", [props.width]);
	return (
		<WidthReactContext.Provider value={props.width}>
			<IsMobileReactContext.Provider value={isMobile}>{props.children}</IsMobileReactContext.Provider>
		</WidthReactContext.Provider>
	);
}

export default withWidth()(Mui3WidthProvider);
